
import apiClient from '@/axios'; // Импортируем настроенный axios


export default {
    async getMedicalStaff() {
      const response = await apiClient.get('/admin/medical-info');
      return response.data.data;
    },

    async getMedicalInfoById(id, role) {
      const BASE_URL = 'https://pulsapp.kz';
      const response = await apiClient.get(`/admin/medical-info/${id}`, {
        params: { role }, // Передаём роль как параметр
      });

      // Преобразуем пути сертификатов
      if (response.data.certificates) {
        response.data.certificates = response.data.certificates.map(
          cert => `${BASE_URL}/storage/${cert}`
        );
      }

      return response.data;
    }

  };